import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from 'vue'
import { StatusVerbal, StatusVerbalCode } from '@/utils/enum/StatusVerbal'
import colorStatusVerbal from '@/utils/helpers/colorStatusVerbal'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusVerbal',
  props: {
  status: {
    type: String as PropType<StatusVerbal>
  },
  code: {
    type: String as PropType<StatusVerbalCode>
  }
},
  setup(__props) {

const props = __props



const statusDefine = computed(() => props.status)
const statusDefineCode = computed(() => props.code)

const colorStatus = () => {
  if (statusDefine.value) {
    const {
      color,
      backgroundColor
    } = colorStatusVerbal(statusDefineCode.value)
    return {
      color,
      backgroundColor,
      border: `1px solid ${color}`
    }
  } return {}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "px-4 py-2 inline rounded-lg container-sts-vbl font-bold text-sm",
    style: _normalizeStyle(colorStatus())
  }, _toDisplayString(_unref(statusDefine)), 5))
}
}

})